import { render, staticRenderFns } from "./purchase-list-types.vue?vue&type=template&id=cfa44840&scoped=true&"
import script from "./purchase-list-types.vue?vue&type=script&lang=js&"
export * from "./purchase-list-types.vue?vue&type=script&lang=js&"
import style0 from "./purchase-list-types.vue?vue&type=style&index=0&id=cfa44840&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa44840",
  null
  
)

export default component.exports